import { ProgressBarService } from '@api/index'
import { DataService } from '@/api'
import { get } from 'lodash'
const SERVICE = new ProgressBarService('progress-bar')

export default {
  getTaskCount(context, params) {
    context.commit('updateTaskCount', {
      namespace: params.namespace,
      value: { count: null, dependencies: [] }
    })
    return new Promise((resolve, reject) => {
      return SERVICE.getTaskCount(params)
        .then(response => {
          context.commit('updateTaskCount', {
            namespace: params.namespace,
            value: response.data.result
          })
          resolve(response.data.result)
        })
        .catch(error => reject(error))
    })
  },
  getTaskSettingsData(context, params) {
    return new Promise(resolve => {
      return SERVICE.getTaskData(params).then(response => {
        context.commit('updateTaskSettingsData', {
          namespace: params.namespace,
          value: response.data.result
        })
        resolve(response.data.result)
      })
    })
  },
  getTaskData(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getTaskData(params)
        .then(response => {
          context.commit('updateTaskData', {
            namespace: params.namespace,
            value: response.data.result
          })
          resolve(response.data.result)
        })
        .catch(error => reject(error))
    })
  },
  getQuickviewData(context, params) {
    return new Promise(resolve => {
      return SERVICE.getQuickviewData(params).then(response => resolve(response.data.result))
    })
  },
  dismiss(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.dismiss(params)
        .then(response => {
          resolve(response.data.result)
          if (!get(response, 'data.result.errors')) {
            return Promise.all([
              context.dispatch('progressBar/getTaskData', params, {
                root: true
              })
            ])
          }
        })
        .catch(error => reject(error))
    })
  },
  process(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.process(params)
        .then(response => {
          resolve(response.data.result)
          if (
            !get(response, 'data.result.errors') &&
            ((params.data.hasOwnProperty('finalized') && params.data.finalized) ||
              !params.data.hasOwnProperty('finalized'))
          ) {
            return Promise.all([
              context.dispatch('progressBar/getTaskData', params, {
                root: true
              })
            ])
          }
        })
        .catch(error => reject(error))
    })
  },
  update(context, params) {
    const SERVICE = new DataService(params.namespace)

    return new Promise((resolve, reject) => {
      SERVICE.update(params)
        .then(response => resolve(response.data.result))
        .catch(reject)
    })
  },
  previewAttachment(context, params) {
    const SERVICE = new DataService(params.namespace)
    return new Promise(resolve => {
      return SERVICE.downloadWithParams(params.value).then(response => {
        let type = response.headers['content-type']
        let blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = params.filename
        link.click()
        resolve(response)
      })
    })
  }
}
